import { currentTenant } from '@/constants'

const { tenantCode = '', tenantName = '', gaodeJsApiKey = '' } = JSON.parse(window.sessionStorage.getItem(currentTenant) || '{}')
export default {
  /**
   * 字典数据中key值对应的注释：
   * 00003：性别
   * 00005：民族
   * 00006：学历
   * 00507：学习专业
   * 01198：审判执行案件类型
   * 90000：专业特长
   * YJ_AJ_ZT：案件状态
   * YJ_PS_CYZT：陪审状态
   * YJ_PS_TCYY：陪审退出原因
   * YJ_PSY_ZT：陪审员状态
   * YJ_TS_ZT：庭审状态
   * YJ_XX_LX：消息类型
   * YJ_XQ_AH：兴趣爱好
   */
  dictData: {},
  // 陪审员用户信息
  userData: {},
  tenant: {
    tenantId: tenantCode,
    tenantName: tenantName,
    config: {
      map: {
        version: '',
        key: gaodeJsApiKey
      },
      weixin: {
        name: tenantName,
        qrcode: tenantName
      }
    }
  },
  userAvatar: require('@/assets/images/default_avatar.png'),
  // 钉钉环境中的corpId
  corpId: window.sessionStorage.getItem('corpId') || null,
  ddCount: window.sessionStorage.getItem('ddCount') || 0,
  // 用户角色 COURT_STAFF  ADMIN JUROR  3种枚举值
  roles: [],
  // 用户信息，不论角色
  userInfo: {},
  // 是否已经根据角色动态添加路由
  isAddedRoutes: false
}



// WEBPACK FOOTER //
// ./src/store/state.js